export default __webpack_public_path__ + "static/media/ro-border.a59747c9.svg";